var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistantCloseIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F2F3EF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23637_4789",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23637_4789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 22C7.71667 22 7.47917 21.9042 7.2875 21.7125C7.09583 21.5208 7 21.2833 7 21C7 20.7167 7.09583 20.4792 7.2875 20.2875C7.47917 20.0958 7.71667 20 8 20H19C19.2833 20 19.5208 20.0958 19.7125 20.2875C19.9042 20.4792 20 20.7167 20 21C20 21.2833 19.9042 21.5208 19.7125 21.7125C19.5208 21.9042 19.2833 22 19 22H8ZM22.9 20.3L19.3 16.7C19.1 16.5 19 16.2667 19 16C19 15.7333 19.1 15.5 19.3 15.3L22.9 11.7C23.0833 11.5167 23.3167 11.425 23.6 11.425C23.8833 11.425 24.1167 11.5167 24.3 11.7C24.4833 11.8833 24.575 12.1167 24.575 12.4C24.575 12.6833 24.4833 12.9167 24.3 13.1L21.4 16L24.3 18.9C24.4833 19.0833 24.575 19.3167 24.575 19.6C24.575 19.8833 24.4833 20.1167 24.3 20.3C24.1167 20.4833 23.8833 20.575 23.6 20.575C23.3167 20.575 23.0833 20.4833 22.9 20.3ZM8 17C7.71667 17 7.47917 16.9042 7.2875 16.7125C7.09583 16.5208 7 16.2833 7 16C7 15.7167 7.09583 15.4792 7.2875 15.2875C7.47917 15.0958 7.71667 15 8 15H16C16.2833 15 16.5208 15.0958 16.7125 15.2875C16.9042 15.4792 17 15.7167 17 16C17 16.2833 16.9042 16.5208 16.7125 16.7125C16.5208 16.9042 16.2833 17 16 17H8ZM8 12C7.71667 12 7.47917 11.9042 7.2875 11.7125C7.09583 11.5208 7 11.2833 7 11C7 10.7167 7.09583 10.4792 7.2875 10.2875C7.47917 10.0958 7.71667 10 8 10H19C19.2833 10 19.5208 10.0958 19.7125 10.2875C19.9042 10.4792 20 10.7167 20 11C20 11.2833 19.9042 11.5208 19.7125 11.7125C19.5208 11.9042 19.2833 12 19 12H8Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantCloseIconNew);
export default __webpack_public_path__ + "static/media/ai_assistant_close_icon_new.973041baddc705ddbac472ce83115d48.svg";
export { ForwardRef as ReactComponent };